'use client';

import { Tooltip } from '@sortlist-frontend/design-system/legacy';
import { ImageSourceHelper } from '@sortlist-frontend/media';
import Image from 'next/image';

import { useWorkMessage } from '_components/common/WorkDetailModal/WorkDetailModalEmbed';
import { onImageError } from '_core/media/get-media.utils';
import { Agency, WorkIncludedAttributes } from '_types/public-api';

type WorkCardWithModalProps = {
  work: WorkIncludedAttributes;
  agency: Agency;
  works: WorkIncludedAttributes[];
  currentIndex: number;
};

export const WorkCardWithModal = (props: WorkCardWithModalProps) => {
  const { work, currentIndex, agency } = props;

  const { sendMessage } = useWorkMessage();

  const onClick = () => {
    sendMessage('open-work-dialog', {
      workSlug: work.attributes.slug,
      agencyId: agency.id,
      currentIndex,
    });
  };

  const IMAGE_WIDTH = 320;

  return (
    // TODO: Remove this and use the component used on the profile. This is unecessary code duplication leading to problems (layout issues for instance) that we don't see right away and need to fix afterwards.
    <div className="p-2">
      <div className="layout-column pb-2" style={{ maxWidth: IMAGE_WIDTH }}>
        <div className="relative bg-secondary-50 work-card-thumbnail">
          <Image
            src={ImageSourceHelper.fromUrl(
              work.attributes.illustration_url || '/_img/default/default-image-landscape.svg',
              {
                width: 960,
              },
            )}
            loading={'lazy'}
            alt={work.attributes.name}
            onError={onImageError}
            className="cursor-pointer rounded-md shadow-2"
            onClick={onClick}
            width={IMAGE_WIDTH}
            height={225}
            role="presentation"
          />
        </div>
        <Tooltip placement="top" title={work.attributes.name}>
          <p className="bold text-truncate cursor-pointer py-4 pl-2 mb-1">{work.attributes.name}</p>
        </Tooltip>
      </div>
    </div>
  );
};
